import isEmpty from 'lodash-es/isEmpty'
import React from 'react'

import { Dashboard } from '@components/common'
import { HeadContent, Pagination, usePagination } from '@fourthwall/components'

import { DonationsData } from './components/DonationsData/DonationsData'
import { DonationsEmptyState } from './components/DonationsEmpyState/DonationsEmptyState'
import { useDonationsQuery } from './queries/useDonationsQuery'

export const PER_PAGE = 25

export const DonationsList = () => {
  const [currentPage, setCurrentPage] = usePagination()
  const { donationsQuery } = useDonationsQuery([{ page: currentPage - 1, size: PER_PAGE }], {
    keepPreviousData: true,
  })
  const donations = donationsQuery.data?.donations || []
  const totalPages = donationsQuery.data?.page.totalPages
  const isFetching = donationsQuery.isInitialLoading

  return (
    <>
      <HeadContent title="Donations" />

      {!isEmpty(donations) || isFetching ? (
        <>
          <Dashboard.Section.Item>
            <DonationsData data={donations || []} isLoading={isFetching} />
          </Dashboard.Section.Item>

          {totalPages && totalPages > 0 && (
            <Dashboard.Section.Item>
              <Pagination
                pageCount={totalPages}
                currentPage={currentPage}
                onChange={setCurrentPage}
              />
            </Dashboard.Section.Item>
          )}
        </>
      ) : (
        <Dashboard.Section.Item>
          <DonationsEmptyState />
        </Dashboard.Section.Item>
      )}
    </>
  )
}
